﻿import React from 'react';
import {connect} from 'react-redux';

import ShortString from '../../../DynamicForms/FormComponents/ShortString';
import LongString from '../../../DynamicForms/FormComponents/LongString';
import Number from '../../../DynamicForms/FormComponents/Number';
import RadioButtons from '../../../DynamicForms/FormComponents/RadioButtons';
import Checkbox from '../../../DynamicForms/FormComponents/Checkbox';
import Dropdown from '../../../DynamicForms/FormComponents/Dropdown';
import FreetextDropdown from '../../../DynamicForms/FormComponents/FreetextDropdown';

import {
    pensionGuidanceFormInputChangeAction,
    validatePensionGuidanceFormInputAction
} from '../State/actions';

import {
    isPositiveInteger,
    validPersonalIdentityNo,
    validEmail,
    validYearAndMonth,
    isValidDate
} from '../../../Forms/Validation/rules';

import throttle from '../../../Utils/throttle';

const inputThrottleTime = 300;

class PensionGuidanceQuestionTypeHandler extends React.PureComponent {
    constructor(props) {
        super(props);

        this.validator = undefined;

        const inputValue = this.props.formInput
            ? this.props.formInput.value
            : (this.props.question.value ? this.props.question.value : '');

        this.state = { value: inputValue };
    }

    // throttling needed when updating redux state for this many inputs, see related discussion at:
    // https://github.com/erikras/redux-form/issues/454
    handleInputChange = (e, throttle = true) => {
        let questionValue;

        if (this.props.question.questionType === 'Checkbox') {
            questionValue = e.target.checked ? this.props.question.options[0].text : '';
        } else {
            questionValue = e.target.value;
        }

        if (throttle) {
            this.props.pensionGuidanceThrottledFormInputeChange(this.props.question.id, questionValue, this.validator);
        } else {
            this.props.pensionGuidanceFormInputChange(this.props.question.id, questionValue, this.validator);
        }

        this.setState({ value: questionValue });
    }

    // validate and take throttle timeout into account
    validate = () => {
        setTimeout(() => this.props.validatePensionGuidanceFormInput(this.props.question.id, this.validator), inputThrottleTime);
    }

    // TODO: verify that PureComponent gives better performance than manually checking props (pretty sure they're kinda equal)
    //shouldComponentUpdate(nextProps, nextState) {
    //    return this.state.value !== nextState.value ||
    //        this.props.formInput.touched !== nextProps.formInput.touched ||
    //        this.props.formInput.valid !== nextProps.formInput.valid;
    //}

    render() {
        const question = this.props.question;
        const currentStep = this.props.currentStep;

        let questionType = question.questionType;
        let submittedValue = '';

        const questionId = question.id;
        const questionText = question.questionText;
        const questionHelpText = question.helpText ? question.helpText : null;

        const isUneditable = question.isUneditable;
        const isTouched = typeof this.props.formInput !== 'undefined' && this.props.formInput
            ? this.props.formInput.touched
            : false;
        const isValid = typeof this.props.formInput !== 'undefined' && this.props.formInput
            ? this.props.formInput.valid
            : undefined;

        // render input
        switch (questionType) {
            case 'Radio':
                return (
                    <RadioButtons
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Välj ett av alternativen"

                        onChange={e => this.handleInputChange(e, true)}
                        onBlur={this.validate}
                        onClick={e => {
                            e.persist();
                            this.props.toggleSubQuestions(e);
                            setTimeout(() => this.validate(), 200);
                        }}
                    />
                );

            case 'Money':
            case 'ShortString':
                return (
                    <ShortString
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Fältet måste fyllas i"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'LongString':
                return (
                    <LongString
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Fältet måste fyllas i"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'Number':
                this.validator = isPositiveInteger;

                return (
                    <div>
                        <Number
                            question={question}

                            value={this.state.value}
                            isValid={isValid}
                            isTouched={isTouched}
                            invalidError="Ange en siffra utan decimaler"

                            onChange={this.handleInputChange}
                            onBlur={this.validate}
                        />

                    </div>
                );

            case 'PersonalIdentityNumber':
                this.validator = validPersonalIdentityNo;

                return (
                    <ShortString
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Ange ett giltigt personnummer"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'EmailAddress':
                this.validator = validEmail;

                return (
                    <ShortString
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Ange en giltig e-postadress"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'Checkbox':
                return (
                    <Checkbox
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Markera kryssrutan"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'FreetextDropdown':
                return (
                    <FreetextDropdown
                        question={question}

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Fältet måste fyllas i"

                        onBlur={this.validate}
                        onChange={e => this.handleInputChange(e)}
                    />
                );

            case 'Dropdown':
                return (
                    <Dropdown
                        question={question}

                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Fältet måste fyllas i"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'MonthAndYear':
                this.validator = validYearAndMonth;
                return (
                    <ShortString
                        question={question}
                        placeholder="ÅÅÅÅ-MM"

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Ange ett datum på formen &quot;ÅÅÅÅ-MM&quot;, t.ex. &quot;2011-10&quot; för Oktober år 2011"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            case 'Date':
                this.validator = isValidDate;
                return (
                    <ShortString
                        question={question}
                        placeholder="ÅÅÅÅ-MM-DD"

                        value={this.state.value}
                        isValid={isValid}
                        isTouched={isTouched}
                        invalidError="Ange ett datum på formen &quot;ÅÅÅÅ-MM-DD&quot;, t.ex. &quot;2011-10-01&quot; för 1:a Oktober år 2011"

                        onChange={this.handleInputChange}
                        onBlur={this.validate}
                    />
                );

            default:
                return null;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.pensionGuidancePageData,
        currentStep: state.pageCurrentStep
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        pensionGuidanceFormInputChange: (questionId, value, validator) => dispatch(pensionGuidanceFormInputChangeAction(questionId, value, validator)),
        pensionGuidanceThrottledFormInputeChange: throttle((questionId, value, validator) => dispatch(pensionGuidanceFormInputChangeAction(questionId, value, validator)), inputThrottleTime),
        validatePensionGuidanceFormInput: (questionId, validator) => dispatch(validatePensionGuidanceFormInputAction(questionId, validator))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PensionGuidanceQuestionTypeHandler);
